import { createAppKit } from '@reown/appkit/react';

import { projectId } from '@/lib/wagmi';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { useRelayChains } from '@reservoir0x/relay-kit-hooks';
import { RelayKitProvider, RelayKitTheme } from '@reservoir0x/relay-kit-ui';
import { MAINNET_RELAY_API } from '@reservoir0x/relay-sdk';
import { QueryClient } from '@tanstack/react-query';
import { PropsWithChildren, useEffect, useState } from 'react';
import { createConfig, WagmiProvider } from 'wagmi';

const metadata = {
  name: 'Portal Frontend',
  description: 'Frontend for the Plume Portal',
  url: 'https://portal.plume.org',
  icons: ['/assets/plume-logo-icon.svg'],
};

const theme: RelayKitTheme = {
  font: 'Inter',
  buttons: {
    primary: {
      background: '#111',
      hover: {
        background: '#333',
      },
    },
  },
};

const PLUME_PRIVATE_CHAIN_ID = 'e696b420-e986-4902-a5fd-2a5f98d86f50';

export const ReownAppKitProvider = ({ children }: PropsWithChildren & { queryClient: QueryClient }) => {
  const [wagmiConfig, setWagmiConfig] = useState<ReturnType<typeof createConfig> | undefined>();
  const { chains, viemChains } = useRelayChains(MAINNET_RELAY_API, {
    includeChains: PLUME_PRIVATE_CHAIN_ID,
  });

  useEffect(() => {
    if (!wagmiConfig && chains && viemChains && viemChains.length > 0) {
      const adapter = new WagmiAdapter({
        networks: viemChains,
        projectId,
        ssr: false,
      });
      setWagmiConfig(adapter.wagmiConfig);

      createAppKit({
        adapters: [adapter],
        // @ts-expect-error TODO: fix this
        networks: viemChains,
        projectId,
        metadata,
        features: {
          analytics: true, // Optional - defaults to your Cloud configuration
          socials: false,
          email: false,
        },
        themeVariables: {
          '--w3m-z-index': 100000,
        },
      });
    }
  }, [chains, viemChains, wagmiConfig]);

  if (!wagmiConfig) {
    return null;
  }

  return (
    // @ts-expect-error allow this
    <RelayKitProvider
      options={{
        appName: 'Plume',
        baseApiUrl: MAINNET_RELAY_API,
        chains,
        privateChainIds: [PLUME_PRIVATE_CHAIN_ID],
        duneConfig: {
          // TODO: move to env
          apiKey: '1lcvcJyXRp9iBaC45I1hyO80nyDgSd0g',
        },
      }}
      theme={theme}
    >
      <WagmiProvider config={wagmiConfig}>{children}</WagmiProvider>
    </RelayKitProvider>
  );
};
